import { render, staticRenderFns } from "./rankingCopy.vue?vue&type=template&id=ad474272&scoped=true"
import script from "./rankingCopy.vue?vue&type=script&lang=js"
export * from "./rankingCopy.vue?vue&type=script&lang=js"
import style0 from "./rankingCopy.vue?vue&type=style&index=0&id=ad474272&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad474272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad474272')) {
      api.createRecord('ad474272', component.options)
    } else {
      api.reload('ad474272', component.options)
    }
    module.hot.accept("./rankingCopy.vue?vue&type=template&id=ad474272&scoped=true", function () {
      api.rerender('ad474272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/rankingCopy.vue"
export default component.exports